import { graphql } from "gatsby"

export const getMenuConfigObject = (data) => {
  // console.log("talent", data && data.prismic && data.prismic.allMenus && data.prismic.allMenus.edges && data.prismic.allMenus.edges[0] && data.prismic.allMenus.edges[0].node)
  return data && data.prismic && data.prismic.allMenus && data.prismic.allMenus.edges && data.prismic.allMenus.edges[0] && data.prismic.allMenus.edges[0].node
}

export const getFooterConfigObject = (data) => {
  return data && data.prismic && data.prismic.allFooter_privacy_policy_linkss && data.prismic.allFooter_privacy_policy_linkss.edges && data.prismic.allFooter_privacy_policy_linkss.edges[0] && data.prismic.allFooter_privacy_policy_linkss.edges[0].node.footer_privacy_policy_links
}

export const getCookiesConfigObject = (data) => {
  return data && data.prismic && data.prismic.allCookie_consents && data.prismic.allCookie_consents.edges && data.prismic.allCookie_consents.edges[0] && data.prismic.allCookie_consents.edges[0].node
}
